export const LABELS = {
  OLD_PW: "現在のパスワード",
  NEW_PW: "新しいパスワード",
  CONFIRM_PW: "新しいパスワード（確認）",
  CODE: "検証コード",
  RESEND_CODE: "再送信",
} as const;
